<template>
  <b-card no-body class="page-header-card" md="12" style="margin-bottom:4px">
    <div class="page-header-layout">
      <div class="page-header-main">
        <div class="page-header-content">
          <b-button
            v-if="backButton"
            variant="flat-primary"
            class="btn-icon page-header-back"
            @click="onBack"
          >
            <feather-icon icon="ArrowLeftIcon"/>
          </b-button>
          <app-breadcrumb :title="name" />
        </div>
      </div>
      <div
        v-if="hasActions"
        class="page-header-actions"
      >
        <slot/>
      </div>
    </div>
  </b-card>
</template>

<script>
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'

export default {
  name: 'PageHeader',
  components: {AppBreadcrumb},
  props: {
    name: {
      type: String,
      required: false,
      default: ''
    },
    backButton: {
      type: Boolean,
      default: false,
      required: false,
    },
    backTo: {
      type: String,
      default: '',
      required: false,

    },
  },
  computed: {
    hasActions() {
      return Boolean(this.$slots.default && this.$slots.default.length)
    },
  },
  methods: {
    onBack() {
      if (this.backTo !== '') {
        this.$router.push(this.backTo)
        return
      }
      this.$router.back()
    },
  },
}
</script>

<style scoped>
.page-header-card {
  padding: 0.5rem
}

.page-header-card :deep(.content-header-title) {
  border-right: none !important;
  padding-right: 0 !important;
}

.page-header-layout {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.page-header-main {
  flex: 1;
  min-width: 0;
}

.page-header-content {
  display: flex;
  align-items: flex-start;
  gap: 0.25rem;
}

.page-header-back {
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.page-header-actions {
  flex-shrink: 0;
  padding-top: 0.125rem;
}

@media (max-width: 767.98px) {
  .page-header-layout {
    flex-direction: column;
    gap: 0.375rem;
  }

  .page-header-main,
  .page-header-actions {
    width: 100%;
  }

  .page-header-actions {
    display: flex;
    justify-content: flex-end;
    padding-top: 0;
  }

  .page-header-card :deep(.content-header-title) {
    font-size: 1.1rem;
    line-height: 1.3;
  }

  .page-header-card :deep(.breadcrumb-wrapper) {
    display: none !important;
  }
}
</style>
